<template>
  <div class='smd-date-input'>
    <input type='text' ref='input'
           :value="displayValue"
           :placeholder="computedPlaceholder"
           :error="error"
           :minDate="minDate"
           :maxDate="maxDate"
           :disabled="disabled"/>
    <span v-if="showIcon" class="smd-icon-util-date"></span>
  </div>
</template>

<script>
  import Pikaday from 'pikaday'
  import moment from 'moment';
  import 'pikaday/css/pikaday.css';

  const SUPPORTED_INPUT_FORMAT = ['MM/DD/YYYY','M/D/YYYY', 'MMM D YYYY'];
  const DT_PICKER_FORMAT = 'MM/DD/YYYY';

  export default {
    name: 'smd-date-input',
    props: {
      dateFormat: {type: String, default: DT_PICKER_FORMAT},
      error: Boolean,
      placeholder: String,
      showIcon: {type: Boolean, default: true},
      value: {required: true},
      disabled:  {type: Boolean, default: false},
      hidePicker: {type: Boolean, default: false},
      minDate: { type: [String, Date], default: null },
      maxDate: { type: [String, Date], default: null }

  },
    data() {
      return {
        mounted: false
      }
    },
    methods: {
      calculateMomentValue() {
        if (!this.value) return null;
        return new moment(this.value);
      },
      calculateDisplayValue() {
        const momentValue = this.calculateMomentValue();
        return momentValue ? momentValue.format(this.dateFormat) : null;
      },
      emitValue(value) {
        const isPrevDate = this.value instanceof Date;
        const isNewDate = value instanceof Date;
        const hasChange = (isPrevDate !== isNewDate) || (isPrevDate && isNewDate && this.value.getTime() !== value.getTime());
        this.$emit('input', value);
        if (hasChange) {
          this.$emit('change', value);
        }
      }
    },
    computed: {
      computedPlaceholder() {
        return this.placeholder || this.dateFormat;
      },
      displayValue() {
        if (!this.mounted) return null;
        return this.calculateDisplayValue();
      }
    },
    mounted() {
      const el = this.$refs.input;

      el.pikadayInstance = new Pikaday({
        field: el,
        format: this.dateFormat,
        minDate: this.minDate ? new Date(this.minDate) : null,
        maxDate: this.maxDate ? new Date(this.maxDate) : null,
        parse: (input) => {
          for (let form of SUPPORTED_INPUT_FORMAT) {
            let x = new moment(input, form, true);
            if (x.isValid()) {
              this.emitValue(x.format(form));
              return x.toDate();
            }
          }
          el.value = null;
          this.emitValue(null);

          return null;
        },
        onSelect: () => {
          this.emitValue(new moment(el.value, this.dateFormat).toDate());
        },
        onOpen: () => {
          if (this.hidePicker) {
            this.$refs.input.pikadayInstance.hide();
          }
        }
      });

      this.unwatch = this.$watch('value', (nVal, oldVal) => {
        if (nVal instanceof Date) {
          const isOldValDt = oldVal instanceof Date;
          if (!isOldValDt || (isOldValDt && nVal.getTime() !== oldVal.getTime())) {
            this.$refs.input.pikadayInstance.setDate(nVal);
          }
        }

        if (this.unwatch instanceof Function) {
          this.unwatch();
        }
      }, {immediate: true});

      this.mounted = true;
    }
  }
</script>


<style lang="scss">
  @import 'scss/pogs-util';

  .smd-date-input {
    position: relative;
    height: 36px;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    & > [class*='smd-icon']{
      @extend %flex-row--center-xy;
      pointer-events: none;

      position: absolute;
      top: 0;
      right: 0;

      width: 40px;
      height: 100%;

      &:before{
        color: color(base) !important;
      }
    }
  }

  .pika-single {
    button {
      min-width: unset;
      min-height: unset;
    }
  }
</style>
